import alert_mixin from '@/utils/mixins/alert_mixin';
import EsigningWorkflows from '@/views/config_views/EsigningManagment/EsigningWorkflows/EsigningWorkflows.vue';
import template_form_management_actions_methods from './template_form_management_actions_methods';
import template_form_management_assignment_methods from './template_form_management_assignment_methods';
import template_form_management_computed, {
  create_template_form_management_data,
} from './template_form_management_helpers';

export default {
  name: 'TemplateFormManagement',
  mixins: [alert_mixin],
  components: {
    EsigningWorkflows,
  },
  data: create_template_form_management_data,
  computed: template_form_management_computed,

  mounted() {
    this.active_tab = this.$route?.query?.tab === 'workflows' ? 'workflows' : 'forms';
    this.load_forms_tab_data();
  },

  methods: {
    ...template_form_management_assignment_methods,
    ...template_form_management_actions_methods,
  },

};
